export var LetterClue;
(function (LetterClue) {
    LetterClue[LetterClue["Unknown"] = 0] = "Unknown";
    LetterClue[LetterClue["NotHere"] = 1] = "NotHere";
    LetterClue[LetterClue["Present"] = 2] = "Present";
    LetterClue[LetterClue["Exact"] = 3] = "Exact";
})(LetterClue || (LetterClue = {}));
export function match(attempt, target) {
    let clues = new Array(attempt.length).fill(LetterClue.NotHere);
    let used = new Array(target.length).fill(false);
    for (let i = 0; i < attempt.length; i++) {
        if (target[i] === attempt[i]) {
            clues[i] = LetterClue.Exact;
            used[i] = true;
        }
    }
    for (let i = 0; i < attempt.length; i++) {
        if (clues[i] === LetterClue.Exact)
            continue;
        for (let j = 0; j < target.length; j++) {
            if (!used[j] && attempt[i] === target[j]) {
                used[j] = true;
                clues[i] = LetterClue.Present;
                break;
            }
        }
    }
    return clues;
}
